export const user = (state) => state.user;
export const token = (state) => state.token;
export const loginToken = (state) => state.loginToken;
export const queuedActions = (state) => state.queuedActions;
export const settings = (state) => state.settings;
export const adminSettings = (state) => state.adminSettings;
